import React, { useState, useEffect } from "react";
import Meta from "../../components/Meta";
import Image from "next/image";
import ContactForm from "../../components/contact/ContactForm";
import Link from "next/link";
import VideoWithTwoTitles from "../../components/world-of-impact/videoWithTwoTitle";
import Address from "../../components/contact/address";

const WorldOfImpact = () => {
  const [video, setVideo] = useState(false);
  const [partyTime, setPartyTime] = useState(false);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    // Set target date to 30 days from now
    const target = new Date();
    target.setDate(target.getDate() + 30); // 30 days from now


    const interval = setInterval(() => {
      const now = new Date();
      const difference = target.getTime() - now.getTime();

      const d = Math.floor(difference / (1000 * 60 * 60 * 24));
      setDays(d);

      const h = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setHours(h);

      const m = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      setMinutes(m);

      const s = Math.floor((difference % (1000 * 60)) / 1000);
      setSeconds(s);

      if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
        setPartyTime(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Meta title="World of Impact || Impactoverse" />
      {/* <!-- Page title --> */}
      <section className="relative pt-24 lg:pb-10">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="lg:flex lg:space-x-12">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
        </div>
        <div className="container mx-auto text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            World of
            <span className="animate-gradient"> Impact</span>
          </h1>

          <VideoWithTwoTitles />
          <p className="text-lg dark:text-jacarta-50">
            We’re doing this through immersive, fun interactions & learning that
            paves the way for real-world solutions. We’re creating an engaging,
            safe space to showcase sustainability activities and innovations,
            allowing for collaborations, content and experiences around topics
            you care about. Create, contribute to, or support campaigns that
            align with your values, grow engagement around impact-aligned
            products and services, and build an impact portfolio that showcases
            what matters to you.
          </p>
        </div>
      </section>
      {/* <!-- Intro / Statistics --> */}

      <div className="container py-10">
        <div className="relative overflow-hidden rounded-2.5xl px-16 pt-16 pb-8 shadow-md lg:px-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="md:flex">
            <div className="mb-6 md:w-full">
              <h2 className="font-display text-5xl text-jacarta-700 dark:text-white lg:text-6xl xl:text-7xl uppercase text-center">
                <span className="animate-gradient"> Launching</span> In
              </h2>

              <div className="js-countdown-single-timer mt-3 flex justify-between">
                <span className="countdown-days text-jacarta-700 dark:text-white">
                  <span className="js-countdown-days-number font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {days}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Days
                  </span>
                </span>

                <span className="countdown-hours text-jacarta-700 dark:text-white">
                  <span className="js-countdown-hours-numberm font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {hours}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Hrs
                  </span>
                </span>
                <span className="countdown-minutes text-jacarta-700 dark:text-white">
                  <span className="js-countdown-minutes-number font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {minutes}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Min
                  </span>
                </span>
                <span className="countdown-seconds text-jacarta-700 dark:text-white">
                  <span className="js-countdown-seconds-number font-display text-4xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase ">
                    {seconds}
                  </span>
                  <span className="block text-2xl font-medium tracking-tight">
                    Sec
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="py-10 dark:bg-jacarta-800 bg-light-base">
        <div className="container">
          <div className="lg:flex">
            {/* <!-- Contact Form --> */}
            <div className="lg:w-1/3 lg:pr-5">
              <div className="dark:bg-jacarta-700 mb-6 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl border bg-white p-10">
                <div className="mb-6 flex items-center space-x-5">
                  <h3 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                    Contact Us
                  </h3>
                </div>
                <p className="dark:text-jacarta-300 mb-6 text-lg leading-normal">
                  {
                    "If you’d like to showcase your brand, cause, project, product, or service, get in touch to let us know what it is, and how it aligns with impact."
                  }
                </p>
              </div>
            </div>
            <div className="mb-12 lg:mb-0 lg:w-2/3 lg:pl-12">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorldOfImpact;
